<template>
  <button
    ref="el"
    class="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left text-sm transition-colors"
    :class="active ? 'bg-hazel-100 text-obsidian-900' : 'text-obsidian-700 hover:bg-obsidian-50'"
    @mouseenter="$emit('activate')"
    @click="$emit('select')"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

const props = defineProps<{
  active: boolean;
}>();

defineEmits<{
  activate: [];
  select: [];
}>();

const el = ref<HTMLButtonElement>();

watch(
  () => props.active,
  (isActive) => {
    if (isActive) {
      el.value?.scrollIntoView({ block: 'nearest' });
    }
  },
);
</script>
